const DialogNavigationPosition = {
  Top: 'Top',
  Bottom: 'Bottom'
};

export default DialogNavigationPosition;
